<template>
  <div class="lv_flexalign_center act_layout">
    <div class="act_button" @click="change(25)">+</div>
    <div class="act_button" @click="change(-25)">-</div>
    <div class="percent">{{ sliderValue }}%</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliderValue: 100,
    };
  },
  methods: {
    syncZoom(value) {
      const zoom = Number(value);
      if (!Number.isFinite(zoom) || zoom <= 0) {
        return;
      }
      this.sliderValue = Math.round(zoom * 100);
    },
    change(val) {
      if (this.sliderValue + val === 0 || this.sliderValue + val === 225) {
        return;
      }
      this.sliderValue += val;
      this.$bus.$emit("set-zoom", this.sliderValue / 100);
    },
  },
  mounted() {
    this.$bus.$on("zoom-change", this.syncZoom);
  },
  beforeDestroy() {
    this.$bus.$off("zoom-change", this.syncZoom);
  },
};
</script>

<style lang="scss" scoped>
.percent {
  width: rem(150);
  text-align: center;
}
</style>
